export default __webpack_public_path__ + "static/Cover-3b46c3d103500b5ef187cb33b333bd57.jpg";